import { ROUTE_PARAMS } from "@/constants";
import {
  resolveDealerCdhAccountId,
  useDealerAccountIdsStore,
} from "@/store/useDealerAccountIdsStore";
import { useSupportModeStore } from "@/store/useSupportModeStore";
import { useParams } from "react-router";

/** CDH id of the dealer named by the route, once the IAM/CDH pair is known. */
export const useRouteDealerCdhAccountId = (): string | undefined => {
  const { [ROUTE_PARAMS.ACCOUNT_ID]: routeIamId } = useParams();
  const cdhIdByIamId = useDealerAccountIdsStore((state) => state.cdhIdByIamId);
  const supportModeSession = useSupportModeStore((state) => state.session);

  return resolveDealerCdhAccountId(
    routeIamId,
    cdhIdByIamId,
    supportModeSession
  );
};
